import moment from "moment";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

import { Col } from "react-bootstrap";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import { shipmentOptions } from "pages/common/Analytics/components/Reports/components/ReportForm/reportCustomOptions";
import DatePicker from "components/atoms/DatePicker/DatePicker";

function DateFieldDefault({ useGroupBy = false }: { useGroupBy?: boolean }) {
  const intl = useIntl();
  const { getValues } = useFormContext();
  return (
    <Col className="d-flex flex-md-row flex-sm-column flex-column">
      <div className="mr-3">
        <FormattedMessage id="report.DateFrom" defaultMessage="Date from" />
        <div className="mt-2">
          <DatePicker
            required
            name="report_date_from"
            maxDate={new Date()}
            registerOptions={{
              deps: "report_date_to",
            }}
          />
        </div>
      </div>
      <div className="mt-sm-3 mt-md-0 mr-3">
        <FormattedMessage id="report.DateTo" defaultMessage="Date to" />
        <div className="mt-2">
          <DatePicker
            required
            name="report_date_to"
            maxDate={new Date()}
            validations={{
              validDate: (v: any) =>
                moment(v).isAfter(getValues("report_date_from")) ||
                moment(v).isSame(getValues("report_date_from")) ||
                "Date must be after start date",
            }}
          />
        </div>
      </div>
      {useGroupBy && (
        <div className="mt-sm-3 mt-md-0">
          <FormattedMessage id="report.groupBy" defaultMessage="Group by" />
          <div className="mt-2" style={{ width: "150px" }}>
            <Dropdown useHookForm options={shipmentOptions(intl)} defaultValue="request_date" name="group_by" />
          </div>
        </div>
      )}
    </Col>
  );
}

DateFieldDefault.defaultProps = {
  useGroupBy: false,
};

export default DateFieldDefault;
